export default (server) => {
  server.get('/sites', (schema, request) => {
    return schema.sites.where({ plan_id: request.queryParams.plan_id }).models.map(s => s.attrs)
  })

  server.get('sites/domain_check', () => {
    return { status: Math.random() < 0.5, subdomain: Math.random() < 0.5 }
  })

  server.delete('sites/:id', (schema, request) => {
    const id = request.params.id
    const site = schema.sites.find(id)
    return site.destroy()
  })
}
